import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';
import { CustomerDataModel, CustomerListModel, CustomerShippingDataModel, CustomerShippingListModel, UpdatedShipToStatesDetail, UploadModel, UploadModelFromAdmin, UploadResultModel, createCustomerModel, createShippingModel, updateShippingModel } from '../../../variables/customer';
import { CustomerService } from '../../../services/customer.service';
import { NgbActiveModal, NgbNavChangeEvent, NgbNav, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsByStatesDataModel, StatesDataModel, CountryDataModel } from '../../../variables/states';
import { StatesService } from '../../../services/states.service';
import { SortEvent, SortDirection, SortColumn } from '../../../services/sortable.directive';
import { compare } from '../../../variables/constant';
import { DatePipe } from '@angular/common';
import { alphaNumericValidator } from 'src/app/variables/common';
import { environment } from 'src/environments/environment';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { stage_domain } from 'src/app/common/domain';
import { stringify } from 'querystring';
import { state } from '@angular/animations';
import { FormService } from 'src/app/services/form.service';
import { AuthService } from 'src/app/services/auth.service';
import { PdfService } from 'src/app/services/pdf.services';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-customer-modal',
    templateUrl: './customer-management-add-edit.component.html',
    styleUrls: ['./customer-management-add-edit.component.scss']
})
export class CustomerManagementAddEditComponent implements OnInit {
    @ViewChild('uploadcertificateHTML', { static: false }) uploadcertificateHTML!: ElementRef;
    @ViewChild('shipToStatesDataHTML', { static: false }) shipToStatesDataHTML!: ElementRef;
    @Input() customer: any;
    NoWhiteSpaceValidator = Validators.pattern(/^\S*$/);

    frmCustomer: FormGroup;
    submitted: boolean = false;
    frmShipping: UntypedFormGroup;
    frmUploadCertificate: UntypedFormGroup
    // frmUploadForm : FormGroup;
    submittedShipping: boolean = false;
    submittedShippingUpload: boolean = false;
    stateList: StatesDataModel[] = [];
    stateListwithAddStates: StatesDataModel[] = [];
    countryList: CountryDataModel[] = [];
    selectedCustomerCountry: any = "";
    countryListPromise: Promise<void>;
    active: number = 0;
    shippingListAll: CustomerShippingDataModel[] = [];
    shippingList: CustomerShippingDataModel[] = [];
    collectionSizeShipping: number = 0;
    pageShipping: number = 1;
    pageSizeShipping: number = 10;
    selectedShipping: CustomerShippingDataModel;
    isAddNewShipping: boolean = false;
    isUploadClicked: boolean = false;
    isCertificateUploadedText: string = '';
    selectedStateforUpload: string = '';
    shippingAccountUploadFormList: FormsByStatesDataModel[] = [];
    readonly autoExemptStates: string[] = ['OR', 'DE', 'MT', 'NH'];
    stateFormId: any = null;
    selectedFile: any = null;
    selectedForm: any = null;
    frmData: FormData = new FormData();
    destinationFile: SafeResourceUrl;
    public sanitizer: DomSanitizer;
    uploadForPayerAccountNumber: string = "";
    PACforHeading: string = "";
    StateforHeading: string = "";
    //sorting
    currentColumn: SortColumn = "";
    currentSortBy: SortDirection = "desc";
    stateSettings = {};
    companyCode = localStorage.getItem('company_code');
    formattedDateTime: string = ''; // For displaying the formatted date-time

    selectedCountry: any;
    selectedSecondaryCountry: any;

    // List of countries with flags and codes
    countries = [
        { code: '+1', name: 'United States', flag: './assets/svg/us.svg' },
        { code: '+91', name: 'India', flag: './assets/svg/in.svg' },
    ];
    isEditShipToSateId;
    isEditShipAccNo;
    newFileName: string;
    referenceNumber: any;
    dateTimeNow: Date;
    emailRecipient: any;
    formId: number;
    formName: string;
    isLoading: boolean = false;
    updatedShipToStates: UpdatedShipToStatesDetail[] = [];
    showShipToStates: boolean = false;

    constructor(
        public formBuilder: UntypedFormBuilder,
        public activeModal: NgbActiveModal,
        public activeModal2: NgbModal,
        private customerService: CustomerService,
        private statesService: StatesService,
        private formService: FormService,
        private authService: AuthService,
        private pdfService: PdfService,
        private datePipe: DatePipe
    ) {
        this.initForm();
        this.getStateList();
        // this.getStateListWithAddStates(); // commented as per new Country -> State flow
        this.countryListPromise = this.getCountryList();
    }

    ngOnInit(): void {
        this.stateSettings = {
            singleSelection: true,
            idField: 'state',
            textField: 'stateName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'Unselect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            maxHeight: 200,
            itemsShowLimit: 5,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No records found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false,
            isLoading: false
        };
        this.patchFormValues();
        // this.frmCustomer.controls['isVip'].valueChanges.subscribe((res) => {
        //     if (res == true) {
        //         this.frmCustomer.controls['isTaxable'].enable();
        //     } else {
        //         this.frmCustomer.controls['isTaxable'].disable();
        //     }
        // })
    }

    get f() { return this.frmCustomer.controls; }
    get fc() { return this.frmShipping.controls; }
    get uc() { return this.frmUploadCertificate.controls; }

    initForm() {
        const formattedDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');

        this.frmCustomer = this.formBuilder.group({
            id: null,
            companyCode: [this.companyCode || null],
            payorAccountNumber: ["", [Validators.required, Validators.maxLength(15), alphaNumericValidator()]],
            customerName: ["", Validators.required],
            dba: [""],
            email: ["", [Validators.required, Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)]],
            secondaryEmail: ["", [Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)]],
            // shippingAccountNumber: ["", Validators.required],
            phoneNumber: ["", [
                Validators.required,
                this.NoWhiteSpaceValidator,
                this.onlyNumbersValidator,
                Validators.minLength(7),
                Validators.maxLength(15)
            ]],
            secondaryPhoneNumber: ["", [
                // Validators.required,
                this.NoWhiteSpaceValidator,
                this.onlyNumbersValidator,
                Validators.minLength(7),
                Validators.maxLength(15)
            ]],
            address: ["", Validators.required],
            city: ["", Validators.required],
            country: ["", Validators.required],
            state: ["", Validators.required],
            pincode: ["", Validators.required],
            isTaxable: ["0"],
            // isVip: [false],
            createdInSAP: [formattedDate, Validators.required]
        });

        this.frmShipping = this.formBuilder.group({
            id: null,
            companyCode: [this.companyCode || null],
            payorAccountNumber: ["", [Validators.required, alphaNumericValidator()]],
            shippingAccountNumber: ["", Validators.required],
            // email: ["", Validators.required],
            // phoneNumber: ["", Validators.required],
            // shipToAddress: ["", Validators.required],
            shipToState: ["", Validators.required],
            // shipToPincode: ["", Validators.required],
            isTaxable: ["1"],
            createdInSAP: [formattedDate, Validators.required],
            selectedForminAddShpAcc: [null],
            uploadFileinAddShpAcc: [null]
        });

        this.frmUploadCertificate = this.formBuilder.group({
            selectedForm: [null],
            UploadPdf: [null]
        })

        setTimeout(() => {
            if (this.customer) {
                this.frmCustomer.controls['createdInSAP'].disable();
                this.frmCustomer.controls['payorAccountNumber'].disable();
            }
            // if (this.frmCustomer.controls['isVip'].value == true) {
            //     this.frmCustomer.controls['isTaxable'].enable();
            // } else {
            //     this.frmCustomer.controls['isTaxable'].disable();
            // }
        })
    }

    patchFormValues() {
        if (this.customer != undefined) {
            // this.frmCustomer.patchValue(this.customer);
            const selectedCountry = this.splitPhoneNumber(this.customer.phoneNumber).countryCode;
            this.selectedCountry = this.countries.find((el) => el.code == selectedCountry);
            this.changePhoneNumberValidation(this.selectedCountry.code);
            const selectedSecondaryCountry = this.splitPhoneNumber(this.customer.secondaryPhoneNumber).countryCode;
            this.selectedSecondaryCountry = this.countries.find((el) => el.code == selectedSecondaryCountry);
            this.changeSecondaryPhoneNumberValidation(this.selectedSecondaryCountry.code);
            this.frmCustomer.patchValue({
                id: this.customer.id,
                companyCode: this.companyCode || null,
                payorAccountNumber: this.customer.payorAccountNumber,
                customerName: this.customer.customerName,
                dba: this.customer.dba,
                email: this.customer.email,
                secondaryEmail: this.customer.secondaryEmail,
                phoneNumber: this.splitPhoneNumber(this.customer.phoneNumber).localNumber,
                secondaryPhoneNumber: this.splitPhoneNumber(this.customer.secondaryPhoneNumber).localNumber,
                address: this.customer.address,
                city: this.customer.city,
                country: this.customer.country,
                pincode: this.customer.pincode,
                isTaxable: this.customer.isTaxable || 0,
                // isVip: this.customer.isVip,
                createdInSAP: this.datePipe.transform(this.customer.createdInSAP, 'yyyy-MM-dd')
            });

            if (this.customer.country) {
                this.countryListPromise.then(() => {
                    // Re-assert the value once options are rendered so the native
                    // <select> reflects the correct selection instead of defaulting
                    // to the first option.
                    this.frmCustomer.controls['country'].setValue(this.customer.country);

                    const selectedCountry = this.countryList.find(c => c.country === this.customer.country);
                    if (selectedCountry) {
                        this.getStatesByCountryId(selectedCountry.id).then(() => {
                            this.frmCustomer.controls['state'].setValue(this.customer.state);
                        });
                    }
                });
            }

            this.getCustomerShippingList();
        } else {
            this.selectedCountry = this.countries[0];
            this.changePhoneNumberValidation(this.selectedCountry.code);
            this.selectedSecondaryCountry = this.countries[0];
            this.changeSecondaryPhoneNumberValidation(this.selectedSecondaryCountry.code);
        }
    }

    async getCustomerShipping(customerId: number): Promise<CustomerShippingListModel[]> {
        let response = await this.customerService.getCustomerShippingsByCustomerId(customerId)
            .toPromise()
            .catch(error => {
                console.log(error);
            });
        if (response instanceof Array) {
            return response.map(obj => {
                return obj;
            });
        }
    }

    getCustomerShippingList() {
        this.getCustomerShipping(this.customer.id).then(data => {
            this.shippingListAll = data;
            this.shippingList = data;
            this.collectionSizeShipping = data.length
        });
    }

    getStateList() {
        this.getStateListData().then(data => {
            this.stateList = data;
        });
    }

    getStateListWithAddStates() {
        this.getStateListDataWithAddStates().then(data => {
            this.stateListwithAddStates = data;
        });
    }

    async getCountryList(): Promise<void> {
        let response = await this.statesService.getCountries()
            .toPromise()
            .catch(error => {
                console.log(error);
            });
        if (response instanceof Array) {
            this.countryList = response;
        } else if (response && response["result"] instanceof Array) {
            this.countryList = response["result"];
        }
    }

    async getStatesByCountryId(countryId: number): Promise<void> {
        let response = await this.statesService.getStatesByCountry(countryId)
            .toPromise()
            .catch(error => {
                console.log(error);
            });
        if (response && response["result"] instanceof Array && response["result"].length > 0) {
            this.stateListwithAddStates = response["result"].map(obj => {
                return {
                    state: obj.state,
                    stateName: obj.stateName,
                    stateNameFull: obj.stateFullName,
                }
            });
        } else {
            // No states available for this country - default state to "OO"
            this.stateListwithAddStates = [
                { state: "OO", stateName: "OO", stateNameFull: "OO" }
            ];
            this.frmCustomer.controls['state'].setValue("OO");
        }
    }

    onCountryChange(countryCode: string) {
        this.frmCustomer.controls['state'].setValue("");
        this.stateListwithAddStates = [];
        const selectedCountry = this.countryList.find(c => c.country === countryCode);
        if (selectedCountry) {
            this.getStatesByCountryId(selectedCountry.id);
        }
    }

    async getStateListData(): Promise<StatesDataModel[]> {
        let response = await this.statesService.getAllStatesData()
            .toPromise()
            .catch(error => {
                if (error instanceof Object) {
                    if (error["message"] != "") {
                        // alert(error["message"]);
                    }
                }
                console.log(error);
            });
        if (response["result"] instanceof Array) {
            return response["result"].map(obj => {
                return {
                    state: obj.state,
                    stateName: obj.stateName,
                    stateNameFull: obj.stateNameFull,
                }
            });
        }
    }

    async getStateListDataWithAddStates(): Promise<StatesDataModel[]> {
        let response = await this.statesService.getAllStatesData()
            .toPromise()
            .catch(error => {
                if (error instanceof Object) {
                    if (error["message"] != "") {
                        // alert(error["message"]);
                    }
                }
                console.log(error);
            });
        if (response["result"] instanceof Array) {
            const apiStates = response["result"].map(obj => {
                return {
                    state: obj.state,
                    stateName: obj.stateName,
                    stateNameFull: obj.stateNameFull,
                }
            });

            const additionalStates: StatesDataModel[] = [
                { state: 'DE', stateName: 'Delaware',      stateNameFull: 'DE - Delaware' },
                { state: 'MT', stateName: 'Montana',       stateNameFull: 'MT - Montana' },
                { state: 'NH', stateName: 'New Hampshire', stateNameFull: 'NH - New Hampshire' },
                { state: 'OR', stateName: 'Oregon',        stateNameFull: 'OR - Oregon' },
            ];

            // Merge, deduplicate by state code, then sort ascending by state abbreviation
            const merged = [...apiStates, ...additionalStates];
            const unique = merged.filter((item, index, self) =>
                index === self.findIndex(s => s.state === item.state)
            );
            return unique.sort((a, b) => a.state.localeCompare(b.state));
        }
    }

    async getShipToStates(customerId: number, shippingAccountId): Promise<UpdatedShipToStatesDetail[]> {
        let response = await this.customerService.getUpdateShipToStates(customerId, shippingAccountId)
            .toPromise()
            .catch(error => {
                console.log(error);
            });
        if (response instanceof Array) {
            return response.map(obj => {
                return obj;
            });
        }
    }

    submitForm() {
        if (this.active === 0) {
            this.submitted = true;
            if (!this.frmCustomer.invalid) {
                let formattedDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
                if (this.f.createdInSAP.value) {
                    const currentDate = new Date(this.f.createdInSAP.value);
                    formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd') + 'T' + this.datePipe.transform(currentDate, 'HH:mm:ss');
                }

                const formData = this.frmCustomer.getRawValue();

                let payload = {
                    id: formData.id,
                    companyCode: formData.companyCode,
                    payorAccountNumber: formData.payorAccountNumber,
                    customerName: formData.customerName,
                    dba: formData.dba,
                    email: formData.email,
                    secondaryEmail: formData.secondaryEmail || null,
                    phoneNumber: this.selectedCountry['code'] + formData.phoneNumber,
                    secondaryPhoneNumber: formData.secondaryPhoneNumber,
                    address: formData.address,
                    city: formData.city,
                    country: formData.country,
                    state: formData.state,
                    pincode: formData.pincode,
                    isTaxable: Number(formData.isTaxable),
                    // isVip: formData.isVip,
                    createdInSAP: formattedDate
                }

                if (this.frmCustomer.controls.secondaryPhoneNumber.value) {
                    payload.secondaryPhoneNumber = this.selectedSecondaryCountry['code'] + this.frmCustomer.controls.secondaryPhoneNumber.value;
                }

                if (this.f.id.value == null) {
                    this.createCustomer(payload).then(data => {
                        if (data != null && data != undefined) {
                            this.frmCustomer.reset();
                            this.closeModal();
                        }
                    });
                } else {
                    this.updateCustomer(payload);
                }
            }
        } else {
            this.submittedShipping = true;
            if (!this.frmShipping.invalid) {
                if (this.fc.id.value == null) {
                    const payload = {
                        id: this.fc.id.value || null,
                        companyCode: this.companyCode,
                        payorAccountNumber: this.customer.payorAccountNumber || null,
                        shippingAccountNumber: this.fc.shippingAccountNumber.value || null,
                        // email: this.fc.email.value || null,
                        // phoneNumber: this.fc.phoneNumber.value || null,
                        // shipToAddress: this.fc.shipToAddress.value || null,
                        shipToState: this.fc.shipToState.value || null,
                        // shipToPincode: this.fc.shipToPincode.value || null,
                        isTaxable: Number(this.fc.isTaxable.value) || 0,
                        createdInSAP: this.fc.createdInSAP.value || null,
                    }

                    if (this.fc.selectedForminAddShpAcc.value !== null) {
                        this.submittedShippingUpload = true;
                        if (this.frmData.get('file') == null) {
                            //this.fc.uploadFileinAddShpAcc.setValue(null);
                            this.fc.uploadFileinAddShpAcc.markAsTouched();
                            return;
                        }
                        this.uploadForPayerAccountNumber = this.customer.payorAccountNumber;
                        this.stateFormId = this.fc.selectedForminAddShpAcc.value.formId;
                        this.formName = this.fc.selectedForminAddShpAcc.value.form;
                        let isUploadCertificate = false;
                        if (this.fc.shipToState.value == 'UT') {
                            if (this.stateFormId == 247) {
                                const confirmed = confirm('Are the purchases going to be less than $1,000? If yes, then please proceed with this form.  If no, then please complete Form TC-721RC');
                                if (!confirmed) {
                                    this.fc.selectedForminAddShpAcc.setValue(null);
                                    this.fc.uploadFileinAddShpAcc.setValue(null);
                                    isUploadCertificate = false;
                                } else {
                                    isUploadCertificate = true;
                                }
                            }

                            if (this.stateFormId == 300) {
                                const confirmed = confirm('Are the purchases going to be more than $1,000? If yes, then please proceed with this form.  If no, then please complete Form TC-73');
                                if (!confirmed) {
                                    this.fc.selectedForminAddShpAcc.setValue(null);
                                    this.fc.uploadFileinAddShpAcc.setValue(null);
                                    isUploadCertificate = false;
                                } else {
                                    isUploadCertificate = true;
                                }
                            }
                        }

                        this.createShipping(payload).then(data => {
                            if (data != null && data != undefined) {
                                this.submittedShippingUpload = false;
                                this.frmShipping.reset();
                                this.cancelSubmit();
                                this.getCustomerShippingList();
                                if (isUploadCertificate) {
                                    this.uploadCertificate();
                                }
                            }
                        });


                    } else {
                        this.createShipping(payload).then(data => {
                            if (data != null && data != undefined) {
                                this.frmShipping.reset();
                                this.cancelSubmit();
                                this.getCustomerShippingList();
                            }
                        });
                    }


                    // this.createShipping(payload).then(data => {
                    //     if (data != null && data != undefined) {
                    //         this.frmShipping.reset();
                    //         this.cancelSubmit();
                    //         this.getCustomerShippingList();
                    //     }
                    // });
                } else {
                    // update

                    const payload = {
                        id: this.fc.id.value || null,
                        payorAccountNumber: this.customer.payorAccountNumber || null,
                        customerName: this.customer.customerName,
                        dba: this.customer.dba,
                        email: this.fc.email.value || null,
                        shippingAccountNumber: this.fc.shippingAccountNumber.value || null,
                        state: this.fc.shipToState.value || null,
                        created: this.fc.createdInSAP.value || null,
                        companyCode: this.companyCode,
                    }
                    this.updateShipping(payload).then(data => {
                        if (data != null && data != undefined) {
                            this.frmShipping.reset();
                            this.cancelSubmit();
                            this.getCustomerShippingList();
                        }
                    });
                }
            }
        }
    }

    async createCustomer(customer: createCustomerModel): Promise<CustomerDataModel> {
        let response = await this.customerService.createCustomer(customer)
            .toPromise()
            .catch(error => {
                if (error["ResponseException"] != "") {
                    alert(error["ResponseException"]);
                } else {
                    alert("Something went wrong");
                }
                console.log(error);
            });
        if (response instanceof Object) {
            if (response["message"] != "" && response["message"] != undefined) {
                alert(response["message"]);
            }
            let result = <any>response["result"];

            return result;
        }

    }

    updateCustomer(customer: createCustomerModel) {
        this.customerService.updateCustomerMaster(customer).subscribe((res) => {
            if (res) {
                this.frmCustomer.reset();
                this.closeModal();
            }
        }, (error) => {
            if (error instanceof Object) {
                if (error["ResponseException"] != "") {
                    alert(error["ResponseException"]);
                }
            }
        })
    }

    cancelSubmit() {
        if ((this.selectedShipping != null || this.isAddNewShipping) && this.active == 1) {
            this.isAddNewShipping = false;
            this.submittedShipping = false;
            this.selectedShipping = null;
            this.isUploadClicked = false;
            this.clearfrmShipping();
        }
        else {
            this.closeModal();
        }
    }

    async createShipping(data: createShippingModel): Promise<CustomerShippingDataModel> {
        let response = await this.customerService.createShipping(data)
            .toPromise()
            .catch(error => {
                if (error instanceof Object) {
                    if (error["ResponseExceptionTitle"] != "" && error["ResponseExceptionTitle"] != undefined) {
                        console.log(this.fc.selectedForminAddShpAcc);
                        if (this.fc.selectedForminAddShpAcc.value == null) {
                            alert(error["ResponseExceptionTitle"]);
                        }
                    }
                }
                if (response["ResponseExceptionTitle"] != "" && response["ResponseExceptionTitle"] != undefined) {
                    alert(response["ResponseExceptionTitle"]);
                }
                console.log(error);
            });
        if (response instanceof Object) {
            // if (response["message"] != "" && response["message"] != undefined) {
            //     alert(response["message"]);
            // }
            let result = <any>response["result"];

            return result;
        }

    }

    async updateShipping(data: updateShippingModel): Promise<any> {
        let response = await this.customerService.updateShipping(data)
            .toPromise()
            .catch(error => {
                if (error instanceof Object) {
                    if (error["message"] != "") {
                        alert(error["message"]);
                    }
                }
                if (response["message"] != "" && response["message"] != undefined) {
                    alert(response["message"]);
                }
                console.log(error);
            });
        if (response instanceof Object) {
            if (response["message"] != "" && response["message"] != undefined) {
                alert(response["message"]);
            }
            let result = <any>response["result"];

            return result;
        }
    }

    async getFormList(stateService: FormService, state: string): Promise<FormsByStatesDataModel[]> {

        let response = await stateService.getFormsByState(state)
            .toPromise()
            .catch(error => {
                if (error instanceof Object) {
                    if (error["message"] != "") {
                        // alert(error["message"]);
                    }
                }
                console.log(error);
            });
        if (response instanceof Object) {
            if (response["message"] != "" && response["message"] != undefined) {
                alert(response["message"]);
            }
            if (response["result"] instanceof Array) {
                return response["result"].map(obj => {
                    return {
                        formId: obj.formId,
                        state: obj.state,
                        form: obj.form,
                        formType: obj.formType
                    }
                });
            }
            return null;
        }

    }

    async uploadPdf(pdfService: PdfService, fileName: string, payorAccountNumber: string, companyCode: string, obj: FormData): Promise<any> {

        let response = await pdfService.uploadPdfFileFromAdmin(fileName, payorAccountNumber, companyCode, obj)
            .toPromise()
            .catch(error => {
                if (error instanceof Object) {
                    if (error["message"] != "") {
                        alert(error["message"]);
                    }
                }
                console.log(error);
            });
        if (response instanceof Object) {
            if (response["message"] != "" && response["message"] != undefined) {
                // alert(response["message"]);
            }
            if (response instanceof Object) {
                let result = response["result"];

                return result;
            }
            return null;
        }

    }

    async afterUploadPdfFromAdmin(pdfService: PdfService, obj: UploadModelFromAdmin): Promise<UploadResultModel> {

        let response = await pdfService.afterUploadPdfFromAdmin(obj)
            .toPromise()
            .catch(error => {
                if (error instanceof Object) {
                    if (error["message"] != "") {
                        alert(error["message"]);
                    }
                }
                console.log(error);
            });
        if (response instanceof Object) {
            if (response["message"] != "" && response["message"] != undefined) {
                alert(response["message"]);
            }
            let result = <UploadResultModel>response["result"];

            return result;
        }

    }

    onActiveInactiveShipping(data: CustomerShippingDataModel) {
        const confirmed = confirm('Are you sure you want to ' + (data.isActive == true ? 'inactive' : 'active') + ' this shipping?');
        if (confirmed) {
            const isActive = !data.isActive;
            this.customerService.activeInactiveShipping(data.id, isActive).subscribe((res) => {
                if (res) {
                    this.getCustomerShippingList();
                }
            }, (error) => {
                if (error instanceof Object) {
                    if (error["message"] != "") {
                        alert(error["message"]);
                    }
                }
            })
        }
    }

    //mark-as-exempt
    markAsExempt(data: any) {
        const confirmed = confirm('Are you sure you want to do this?');
        if (confirmed) {
            let payload = {
                customerId: data.customerMasterId,
                state: data.shipToState ? data.shipToState?.split(" - ")[0] : '',
            }
            this.customerService.markAsExempt(payload).subscribe((res) => {
                if (res) {
                    this.getCustomerShippingList();
                }
            })
        }
    }

    //mark-as-non-exempt
    markAsNonExempt(data: any) {
        const confirmed = confirm('Are you sure you want to do this?');
        if (confirmed) {
            let payload = {
                customerId: data.customerMasterId,
                state: data.shipToState ? data.shipToState?.split(" - ")[0] : '',
            }
            this.customerService.markAsNonExempt(payload).subscribe((res) => {
                if (res) {
                    this.getCustomerShippingList();
                }
            })
        }
    }

    onNavChange(changeEvent: NgbNavChangeEvent, nav: NgbNav) {
        if (changeEvent.nextId > 0) {
            if (this.f.id.value == null) {
                changeEvent.activeId = 0;
            }
        }

        if (changeEvent.activeId == 1) {
            this.isAddNewShipping = false;
            this.submittedShipping = false;
            this.selectedShipping = null;
            this.isUploadClicked = false;
        }
    }

    selectShipping(data: CustomerShippingDataModel) {
        if (data == null) {
            this.isUploadClicked = false;
            this.clearfrmShipping();
            this.isAddNewShipping = true;
        }
        else {
            this.frmShipping.patchValue(
                {
                    id: data?.id,
                    companyCode: this.companyCode,
                    payorAccountNumber: this.customer.payorAccountNumber,
                    shippingAccountNumber: data.shippingAccountNumber,
                    shipToState: data?.shipToState || null,
                    isTaxable: data?.isTaxable || '0',
                    createdInSAP: data?.createdInSAP,
                }
            );
            this.selectedShipping = data;
        }
    }


    clearfrmShipping() {
        this.submittedShipping = false;
        this.selectedShipping = null;
        this.frmShipping.reset();
        this.frmShipping.controls['companyCode'].setValue(this.companyCode);
        const formattedDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        this.frmShipping.controls['createdInSAP'].setValue(formattedDate);

        // this.frmShipping.controls['isTaxable'].setValue(false);
        if (this.customer) {
            this.frmShipping.controls['payorAccountNumber'].setValue(this.customer.payorAccountNumber);
            this.frmShipping.controls['payorAccountNumber'].disable();
        }
        this.frmShipping.controls['shipToState'].setValue("");
        const isTaxableVal = this.frmShipping.controls['isTaxable'].value;
        this.frmShipping.controls['isTaxable'].setValue(isTaxableVal ? isTaxableVal : '1');
        // if (this.customer?.isVip == true) {
        //     this.frmShipping.controls['isTaxable'].enable();
        // } else {
        //     this.frmShipping.controls['isTaxable'].disable();
        // }
    }

    // Handle country selection
    selectCountry(country: any) {
        this.selectedCountry = country;
        this.changePhoneNumberValidation(country.code);
    }

    changePhoneNumberValidation(res: string) {
        const phoneControl = this.frmCustomer.get("phoneNumber");
        if (!phoneControl) return;
        if (res === "+91") {
            phoneControl.setValidators([
                Validators.required,
                this.NoWhiteSpaceValidator,
                this.onlyNumbersValidator,
                Validators.minLength(10),
                Validators.maxLength(10)
            ]);
        } else {
            phoneControl.setValidators([
                Validators.required,
                this.NoWhiteSpaceValidator,
                this.onlyNumbersValidator,
                Validators.minLength(7),
                Validators.maxLength(15)
            ]);
        }
        phoneControl.updateValueAndValidity();
    }
    selectSecondaryCountry(country: any) {
        this.selectedSecondaryCountry = country;
        this.changeSecondaryPhoneNumberValidation(country.code);
    }

    changeSecondaryPhoneNumberValidation(res: string) {
        const secondaryPhoneNumber = this.frmCustomer.get("secondaryPhoneNumber");
        if (!secondaryPhoneNumber) return;
        if (res === "+91") {
            secondaryPhoneNumber.setValidators([
                this.NoWhiteSpaceValidator,
                this.onlyNumbersValidator,
                Validators.minLength(10),
                Validators.maxLength(10)
            ]);
        } else {
            secondaryPhoneNumber.setValidators([
                this.NoWhiteSpaceValidator,
                this.onlyNumbersValidator,
                Validators.minLength(7),
                Validators.maxLength(15)
            ]);
        }
        secondaryPhoneNumber.updateValueAndValidity();
    }

    resetPage() {
        this.pageShipping = 1;
    }

    closeModal() {
        this.activeModal.close();
    }

    onSort(event) {
        var column = event.target.getAttribute("sortable");
        if (this.currentColumn !== column && this.currentColumn !== "") {
            this.currentColumn = column;
            this.currentSortBy = "asc"; //revert to default sort      
        } else {
            if (this.currentColumn == "") { //first sort
                this.currentColumn = column;
                if (this.currentColumn == "firstName") { //by default, firstName is already sorted to asc
                    this.currentSortBy = "desc";
                }
            } else {
                if (this.currentSortBy == "asc") {
                    this.currentSortBy = "desc";
                } else {
                    this.currentSortBy = "asc";
                }
            }
        }
        this.shippingList = this.sortData(this.shippingList, column, this.currentSortBy);
    }

    sortData(datalist: any[], column: SortColumn, direction: SortDirection): any[] {
        if (direction === '' || column === '') {
            return datalist;
        } else {
            return [...datalist].sort((a, b) => {
                const res = compare(a[column], b[column]);
                return direction === 'asc' ? res : -res;
            });
        }
    }

    onDateChange(): void {
        if (this.fc.createdInSAP.value) {
            const dateTime = new Date(this.fc.createdInSAP.value);
            this.fc.createdInSAP.setValue(this.toDateTimeLocal(new Date(dateTime.toISOString())));
        }
    }

    toDateTimeLocal(date: Date): string {
        const ten = (i: number) => (i < 10 ? '0' : '') + i;
        const YYYY = date.getFullYear();
        const MM = ten(date.getMonth() + 1);
        const DD = ten(date.getDate());
        const HH = ten(date.getHours());
        const II = ten(date.getMinutes());
        return `${YYYY}-${MM}-${DD}T${HH}:${II}`;
    }

    splitPhoneNumber(phoneNumber: string) {
        let countryCode = "";
        let localNumber = "";

        const countryCodeIndex = phoneNumber.indexOf("+");
        if (countryCodeIndex !== -1) {
            // Check for +1 (USA) or +91 (India) as the country code
            if (phoneNumber.startsWith("+1")) {
                countryCode = "+1";
                localNumber = phoneNumber.substring(2); // Remove the country code part
            } else if (phoneNumber.startsWith("+91")) {
                countryCode = "+91";
                localNumber = phoneNumber.substring(3); // Remove the country code part
            }
        }
        else {
            countryCode = this.countries[0]['code'];
            localNumber = phoneNumber; // Remove the country code part
        }
        return { countryCode: countryCode || this.countries[0]['code'], localNumber };
    }

    // Custom validator to check if phone number contains only numeric characters
    onlyNumbersValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!/^[0-9]*$/.test(value)) {
            return { invalidCharacters: true };
        }
        return null;
    }

    isTaxableLabel(val) {
        switch (val) {
            case 0:
                return "Exempt";
            case 1:
                return "Taxable";
            default:
                return "Exempt";
        }
    }

    redirectCustomerLogin() {
        if (environment.production) {
            return `https://${this.companyCode + '.' + stage_domain + '/eCert'}`
        } else {
            return 'https://angular-cvt.agiletechnologies.in/eCert';
        }
    }

    updateShipToState(data, value) {
        const modalRef = this.activeModal2.open(CustomModalComponent, { centered: true, ariaLabelledBy: 'customModalTitle' });
        modalRef.componentInstance.title = "Update State";
        modalRef.componentInstance.description = "Are you sure you want to update the state?";
        modalRef.componentInstance.infoIcon = "./assets/img/ExclamationCircle.png";
        modalRef.componentInstance.btnText = "Yes, Update";
        modalRef.result.then(
            (val: any) => {
                if (val == "ok") {
                    const stateData = this.stateList.find(state => state.stateNameFull === value);
                    this.customerService.updateShipToState(data.id, localStorage.getItem('company_code') as string, stateData.state).subscribe(() => {
                        this.isEditShipToSateId = null;
                                this.getCustomerShippingList();
                    }, () => {
                        this.isEditShipToSateId = null;
                    });
                }
            },
            (reason: any) => {
                console.log(reason);
            }
        );
    }

    showUploadCertificate(data: CustomerShippingDataModel) {
        this.isUploadClicked = true;
        setTimeout(() => {
            this.uploadcertificateHTML.nativeElement.focus();
        });
        this.isCertificateUploadedText = data.shippingAccountNumber + " - " + data.shipToState;

        this.selectedStateforUpload = data.shipToState.substring(0, 2);
        this.uploadForPayerAccountNumber = data.payorAccountNumber;

        this.getFormList(this.formService, this.selectedStateforUpload).then(data => {
            this.shippingAccountUploadFormList = data;
        });

    }

    cancelUpload() {
        this.isUploadClicked = false;
        this.isCertificateUploadedText = '';
        this.selectedForm = null;
    }

    onChangeStateFormId(event: Event) {
        this.stateFormId = this.uc.selectedForm.value.formId;
        this.formName = this.uc.selectedForm.value.form;
    }

    onFileChange(event) {
        this.frmData.delete('file');
        let file = event.target.files[0];
        const element = event.currentTarget as HTMLInputElement;

        if (file && file.type !== "application/pdf") {
            alert("Please upload a PDF file");
            element.value = ""; // Clear the selected file
        } else {
            if (file != "" && file != undefined) {
                this.selectedFile = file;
                this.frmData.append('file', file);

                this.checkFileApi(file);
            }
            else {
                this.destinationFile = null;
            }
        }
    }

    checkFileApi(file: File): void {
        this.checkPdfPasswordProtection(file);
    }

    checkPdfPasswordProtection(file: File): void {
        this.pdfService.ispdfpasswordprotected(this.frmData).subscribe(
            (response: any) => {
                console.log('PDF Password Protection Check:', response);

                // Handle the response based on your API structure
                if (response && response.result !== undefined) {
                    const isPasswordProtected = response.result;
                    if (isPasswordProtected) {
                        alert('This PDF file is password protected. Please upload an unprotected PDF file.');
                        // Clear the selected file
                        this.selectedFile = null;
                        this.isCertificateUploadedText = '';
                        this.frmData.delete('file');
                        this.uc.UploadPdf.setValue(null);
                        // Reset file input and clear PDF object
                        const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
                        if (fileInput) {

                            fileInput.value = '';
                        }
                    }
                }
            },
            (error) => {
                console.error('Error checking PDF password protection:', error);
                this.selectedFile = null;
                this.isCertificateUploadedText = '';
                this.frmData.delete('file');
                this.uc.UploadPdf.setValue(null);
                // Reset file input and clear PDF object
                const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
                if (fileInput) {

                    fileInput.value = '';
                }
            }
        );
    }

    uploadCertificateAction() {
        const formVal = this.uc.selectedForm.value.formId;
        if (formVal == 247) {
            const confirmed = confirm('Are the purchases going to be less than $1,000? If yes, then please proceed with this form.  If no, then please complete Form TC-721RC');
            if (!confirmed) {
                this.uc.selectedForm.setValue(null);
                this.uc.UploadPdf.setValue(null);
            }
        } else if (formVal == 300) {
            const confirmed = confirm('Are the purchases going to be more than $1,000? If yes, then please proceed with this form.  If no, then please complete Form TC-73');
            if (!confirmed) {
                this.uc.selectedForm.setValue(null);
                this.uc.UploadPdf.setValue(null);
            }
        } else {
            this.uploadCertificate();
        }
    }

    uploadCertificate() {
        console.log(this.uc.selectedForm.value);
        if (this.uc.selectedForm.value == null) {

            this.uc.selectedForm.markAsTouched();
        }

        if (this.frmData.get('file') == null) {
            this.uc.UploadPdf.markAsTouched();
            return;
        }

        this.isLoading = true;
        let dateNow: Date = new Date();
        let ts: string = dateNow.getFullYear().toString() + dateNow.getMonth().toString() + dateNow.getDate().toString();
        ts += "_" + dateNow.getHours().toString() + dateNow.getMinutes().toString() + dateNow.getSeconds().toString();
        this.newFileName = this.uploadForPayerAccountNumber + "_" + this.formName + "_" + ts + ".pdf";
        this.dateTimeNow = dateNow;
        let obj: UploadModelFromAdmin = <UploadModelFromAdmin>{
            fileName: this.newFileName,
            dateSubmitted: this.dateTimeNow,
            formId: this.stateFormId,
            formName: this.formName,
            payerAccountNumber: this.uploadForPayerAccountNumber,
            comapnyCode: this.companyCode
        };

        this.uploadPdf(this.pdfService, this.newFileName, this.uploadForPayerAccountNumber, localStorage.getItem('company_code'), this.frmData).then(data => {
            if (data != "" && data != undefined) {
                this.afterUploadPdfFromAdmin(this.pdfService, obj).then(data => {
                    this.isLoading = false;
                    if (data != null && data != undefined) {
                        this.referenceNumber = data.referenceNumber;
                        this.isLoading = false;
                    }
                }, () => {
                    this.isLoading = false;
                });
            } else {
                this.isLoading = false;
            }
        }, () => {
            this.isLoading = false;
        });

        this.frmData.delete('file');
        this.isUploadClicked = false;
        this.isCertificateUploadedText = '';
        this.selectedForm = null;
    }

    onChangeAddShippingAccStateFormId(selectedShiptoState: string) {
        this.isUploadClicked = true;
        this.StateforHeading = selectedShiptoState

        this.isCertificateUploadedText = this.PACforHeading + " - " + this.StateforHeading

        if (this.autoExemptStates.includes((selectedShiptoState || '').toUpperCase())) {
            this.frmShipping.controls['isTaxable'].setValue('0');
        }

        this.getFormList(this.formService, selectedShiptoState).then(data => {
            this.shippingAccountUploadFormList = data;
        });
    }

    onChangeshippingAccountNumber(shippingAccountNumber: string) {
        this.PACforHeading = shippingAccountNumber;
        this.isCertificateUploadedText = this.PACforHeading + " - " + this.StateforHeading
    }

    ShipToStates(data: any) {
        this.isLoading = true;
        this.getShipToStates(data.customerMasterId, data.id).then(data => {
            this.updatedShipToStates = data
            if (this.updatedShipToStates.length > 0) {
                this.showShipToStates = true;
                setTimeout(() => {
                    this.shipToStatesDataHTML.nativeElement.focus();
                });
            }
            this.isLoading = false;
        });


    }

    hideShipToStates() {
        this.showShipToStates = false;
    }

    updateShipAccNo(data, value) {
        const modalRef = this.activeModal2.open(CustomModalComponent, { centered: true, ariaLabelledBy: 'customModalTitle' });
        modalRef.componentInstance.title = "Update Shipping Account Number";
        modalRef.componentInstance.description = "Are you sure you want to update the shipping account number?";
        modalRef.componentInstance.infoIcon = "./assets/img/ExclamationCircle.png";
        modalRef.componentInstance.btnText = "Yes, Update";
        modalRef.result.then(
            (val: any) => {
                if (val == "ok") {
                    this.customerService.updateShipAccNo(data.id, value).subscribe((res) => {
                        if (res?.status == "Success") {
                            this.isEditShipAccNo = null;
                            this.getCustomerShippingList();
                        }
                        
                        if (res?.status == "failed") {
                            this.isEditShipAccNo = null;
                            data.shippingAccountNumber = '';
                            alert(res?.message);
                        }
                    }, () => {
                    });
                }
            },
            (reason: any) => {
                console.log(reason);
            }
        );
    }

    editShipping(data: any) {
        this.isEditShipAccNo = data.id;
    }
}
